import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=10cf9fea&scoped=true&"
import script from "./Facility.vue?vue&type=script&lang=js&"
export * from "./Facility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf9fea",
  null
  
)

export default component.exports